import InmediatoIcon from '@images/icons/inmediato.png';
import AlDiaSiguienteIcon from '@images/icons/salida-del-sol.png';
import DeVacacionesIcon from '@images/icons/vacaciones.png';
import NoDisponibleIcon from '@images/icons/no-disponible.png';
import useUsuarioStore from './usuario';

const useAutorStore = defineStore('autor',() => {

  // stados
  const autor = ref({
    id: null,
    tarifa: 6,
    experiencia: "",
    especialidades: [],
    disponibilidad: 1, // 1 => inmediata (Puedo comenzar de inmediato), 2 => Al día siguiente (Puedo comenzar el día de Mañana), 3 => De Vacaciones (no puedo tomar encargos), 4 => NO Disponible
    tiempo_entrega:null,
    anos_experiencia:null,
    como_trabajo:null,
    redes_sociales:[],
    pais_id:null,
  });


  const autores = ref([]);

  // getters

  const draft = computed(() => clone(autor.value));
  const autor_id = computed(() => autor.value ? autor.value.id : null);

  const opciones_disponibilidad = ref([
    {value:1,text:"Inmediata",icono:InmediatoIcon, descripcion:'Puedo comenzar de inmediato'},
    {value:2,text:"Al día siguiente",descripcion:'Puedo comenzar el día de mañana', icono:AlDiaSiguienteIcon},
    {value:3,text:"De Vacaciones", descripcion:'No puedo tomar encargos por vacaciones', icono:DeVacacionesIcon},
    {value:4,text:"No Disponible",descripcion:'No puedo tomar encargos', icono:NoDisponibleIcon},
  ]);

  // mutations

  const clear = () => {
    autor.value = {
      id: null,
      tarifa: 6,
      experiencia: "",
      especialidades: [],
      disponibilidad: 1, // 1 => inmediata (Puedo comenzar de inmediato), 2 => Al día siguiente (Puedo comenzar el día de Mañana), 3 => De Vacaciones (no puedo tomar encargos), 4 => NO Disponible
      tiempo_entrega: null,
      anos_experiencia: null,
      como_trabajo: null,
      redes_sociales: [],
      pais_id: null,
    };
  };

  // actions

  const fetch = (autor_id) => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/autors/${autor_id}/fetch-data`)
      .then(({data}) => {
        autor.value = data;
        resolve(data);
      }).catch(e => {
        reject(e)
      })
    })
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios.post(`/api/autors/fetch-data`,datos)
      .then(({data}) => {
        resolve(data);
      }).catch(e => {
        reject(e)
      })
    })
  };


  const guardar = async (datos) => {
    

    try {
      
      if(datos.id) {

        const {data} = await axios.put(`/api/autors/${datos.id}`,datos);

        if(data.result){
          autor.value = data.autor;
        }
        return data;

      }else{
        const {data} = await axios.post(`/api/autors`,datos);
        if(data.result) autor.value = data.autor;
        return data;
      }

      
    } catch (error) {
      throw error;
    }
  };


  const eliminar = (autor_id) => {
    return new Promise((resolve, reject) => {
      
      axios.delete(`/api/autors/${autor_id}`)
      .then(({data}) => {
        resolve(data);
      }).catch(e => reject(e));

    })
  }

  const fetchSelectList = () => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/autors/select-list`)
      .then(({data}) => {
        resolve(data)
      })
      .catch(e => {
        reject(e)
      })
    })
  };

  const fetchPorUser = async (user_id = null) => {
    if(!user_id){
      const usuario_store = useUsuarioStore();
      user_id = usuario_store.usuario.id;
    }

    try {
        const {data} = await axios.get(`/api/autors/por-usuario/${user_id}`);
        if(data.id) autor.value = data;
        return data;
    } catch (error) {
        throw error;
    }
  };

  const fetchTiposBiografia = async () => {
    try {
      const {data} = await axios.get(`/api/autors/tipos-biografias`);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    // states
    autor,
    autores,
    // getters
    draft,
    opciones_disponibilidad,
    autor_id,
    // methods or actions
    fetch,
    fetchData,
    guardar,
    eliminar,
    clear,
    fetchSelectList,
    fetchPorUser,
    fetchTiposBiografia,
  };

});

export default useAutorStore;